import { FieldErrorsImpl, useFormContext } from 'react-hook-form';
import { TFormBuilderField, TFormBuilderEditSchemaCamel } from '@/types';

/**
 * Hook to get validation errors for a specific form builder field
 * @template T - Type of form builder field
 * @param fieldIndex - Index of the field in the form
 * @returns Validation errors for the field
 */
export const useFormBuilderFieldWithError = <T extends TFormBuilderField>(
  fieldIndex: number,
) => {
  const {
    formState: { errors },
  } = useFormContext<TFormBuilderEditSchemaCamel>();

  const error = errors?.fields?.[fieldIndex];

  return error as FieldErrorsImpl<NonNullable<T>>;
};
